import React from 'react';

export const ArrowUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M10.5 8L6.14635 4.05296C6.12799 4.03631 6.10543 4.02298 6.08017 4.01385C6.05491 4.00472 6.02751 4 5.9998 4C5.9721 4 5.9447 4.00472 5.91944 4.01385C5.89418 4.02298 5.87162 4.03631 5.85326 4.05296L1.5 8"
      stroke="black"
    />
  </svg>
);
